// extracted by mini-css-extract-plugin
module.exports = {"embed":"VideoEmbed-module--embed--2P0u0"};